// extracted by mini-css-extract-plugin
export var carousel = "carousel-module--carousel--1ca05";
export var controls = "carousel-module--controls--f194b";
export var slide = "carousel-module--slide--25b38";
export var sliderTray = "carousel-module--sliderTray--c0bb4";